export const getStyle=(props)=>{
    var inputProps = props?.style?.input ?? props?.style;
    var fieldProps = props?.style?.field ?? props?.style;
    return {input:inputProps, field: fieldProps}
}